import { useIsMobile } from "@/hooks/use-mobile";
import { routes } from "@/routes/utils";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const useAddEditCommunity = () => {
  const { id, action } = useParams();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();
  const isView = action == "view";
  const isEdit = action == "edit" || action == "edit-details";
  const isAdd = action == "add";
  const [currentStep, setCurrentStep] = useState<number>(1);

  useEffect(() => {
    if ((isEdit || isAdd) && location?.state?.step) {
      setCurrentStep(parseInt(location?.state?.step) || 1);
    }
  }, [location, location?.state, action]);

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onBackClick = () => {
    navigate(`/${routes.admin}/${routes.adminConsole}/${routes.communities}`);
  };

  const onStepperClick = (curr_step: number) => {
    if (isView || isEdit) setCurrentStep(curr_step);
  };

  return {
    currentStep,
    setCurrentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    id,
    onPreviousStepClick,
    isMobile,
  };
};

export default useAddEditCommunity;
